import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import "./index.css";
import { production, dev } from "./constants";

const Chatbot = (props) => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(() => {
    return localStorage.getItem("sessionId") || null;
  });
  const chatboxRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const defaultMessage = {
      role: "assistant",
      content:
        "Heyyy! Em là trợ lý ảo của anh Silver ạ. Anh Silver đang bận nên em sẽ ở đây trực, tin nhắn sẽ được gửi tới anh ý định kỳ hàng ngày nhé ạ!",
    };
    setMessages([defaultMessage]);
  }, []);

  useEffect(() => {
    if (chatboxRef.current) {
      chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    let tempInput = input;
    setInput("");
    inputRef.current.value = ""; // Clear the textarea value
    const userMessage = { role: "user", content: tempInput };
    setMessages((prevMessages) => [...prevMessages, userMessage]);

    try {
      setLoading(true);
      let emailRes = "";
      if (tempInput.includes("email")){
        if(localStorage.getItem("silver-key") === "2506") {
          const response = await axios.get(
            "https://mrsilver256.app.n8n.cloud/webhook/7003159f-13d8-46c2-9f33-22229ff29d8f"
          );
          emailRes = response.data;
        }
        tempInput = tempInput.replace("email", "").trim();
      }
      const response = await axios.post(production + "/chat", {
        message: tempInput + "\n" + emailRes,
        sessionId,
      });

      if (response.data.sessionId && !sessionId) {
        setSessionId(response.data.sessionId);
        localStorage.setItem("sessionId", response.data.sessionId);
      }

      const botReply = { role: "assistant", content: response.data.reply };
      setMessages((prevMessages) => [...prevMessages, botReply]);
      setLoading(false);
    } catch (error) {
      console.error("Error sending message:", error);
      setLoading(false);
    }
  };

  const isMobile = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const handleKeyPress = (e) => {
    if (isMobile()) {
      return;
    }

    if (e.key === "Enter" && !e.shiftKey) {
      if (input === "2506") {
        setInput("");
        inputRef.current.value = ""; // Clear the textarea value
        props.changeScreen("train");
      } else {
        sendMessage();
      }
      e.preventDefault(); // Prevent the default behavior of adding a newline
    }
  };

  return [
    <div className="chatbot-container">
      <h1 className="chatbot-title">
        {loading ? "Please wait..." : "Silva - Lovable Bot"}
      </h1>
      <div className="chatbox" ref={chatboxRef}>
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`message ${
              msg.role === "user" ? "user-message" : "assistant-message"
            }`}
          >
            <div className="message-content" style={{ overflowX: "auto" }}>
              <strong>
                {msg.role === "user" ? "You" : "Silva - Lovable Bot"}:
              </strong>{" "}
              <ReactMarkdown>{msg.content}</ReactMarkdown>
            </div>
          </div>
        ))}
      </div>
      <div
        className="input-container"
        style={{ display: "flex", gap: "10px", alignItems: "center" }}
      >
        <textarea
          ref={inputRef}
          type="input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type your message..."
          className="input-box"
        />
        <button onClick={sendMessage} className="send-button">
          Send
        </button>
      </div>
    </div>,
    <div
      style={{
        width: "100%",
        textAlign: "center",
        padding: "16px 0",
        fontFamily: "Arial, sans-serif",
        color: "grey",
      }}
    >
      Made with love by Silver
    </div>,
  ];
};

export default Chatbot;
